<template>
  <div
    class="home-service"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
    }"
  >
    <div class="title">
      <eui-icon icon="eicon-wyfw" color="#333" font-size="18px" />
      <div class="text">综合服务</div>
    </div>
    <div>
      <div v-for="item in list" :key="item.text">
        <icon-animation v-if="item.img" :bg-url="item.img" />
        <div>{{ item.text }}</div>
        <div
          :class="[item.btnText === '申请' ? 'btn-80-30-plain' : 'btn-80-30']"
          @click="toOpen(item)"
        >
          {{ item.btnText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  easySeries,
  insuranceUrl,
  epecMallUrl,
} from '@/modules/projectA/api/config';
import { USER_TYPE, ADMIN } from './constant';
import IconAnimation from './iconAnimation';

export default {
  components: { IconAnimation },
  props: {
    title: {
      type: String,
      default: '',
    },
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    list() {
      let arr = [
        {
          img: require('@/assets/img/home/yibaoxian.png'),
          text: '易保险',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://baoxian.epec.com/toIndex
          url: `${insuranceUrl}/toIndex`,
        },
        {
          img: require('@/assets/img/home/yizhifu.png'),
          text: '易支付',
          btnText: this.isOpeningPayment ? '查看' : '申请',
          hidden: this.administrator !== ADMIN.YES, // 仅限管理员申请，申请后显示查看按钮，其它身份不显示。
          // url: `https://10.248.67.159/`
          url: `/paymentAccount`,
        },
        {
          img: require('@/assets/img/home/yibaoli.png'),
          text: '易保理',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/supplier/businessFactor.do
          url: `${easySeries}/ecmall/supplier/businessFactor.do`,
        },
        {
          img: require('@/assets/img/home/yiquantong.png'),
          text: '易权通',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/staticHtmls/ebillManager.do
          url: `${easySeries}/ecmall/staticHtmls/ebillManager.do`,
        },
        {
          img: require('@/assets/img/home/yiwuliu.png'),
          text: '易物流',
          btnText: '申请',
          hidden: false, // 仅限供应商管理员申请，按钮一直显示申请，其它身份跳转宣传页https://mall.epec.com/ecmall/static/logistics.do
          url: `${easySeries}/ecmall/static/logistics.do`,
          // url: [USER_TYPE.ALL, USER_TYPE.SUPPLY].includes(this.userType) && this.administrator === ADMIN.YES ? `${url.oldService}/memberportal/zh/companyTransport/init.do` : `${url.easySeries}/ecmall/static/logistics.do`
        },
        {
          img: require('@/assets/img/home/yishanglv.png'),
          text: '易派客商旅',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/epecTravel/epecTravel.do
          url: `${easySeries}/ecmall/epecTravel/epecTravel.do`,
        },
        {
          img: require('@/assets/img/home/yishenghuo.png'),
          text: '易生活',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/static/xfpZone.do
          url: `https://emall.epec.com/brandMall?companyId=5528459&columeId=3&shopId=125&companyName=%E6%98%93%E6%B4%BE%E5%AE%A2%E7%94%B5%E5%AD%90%E5%95%86%E5%8A%A1%EF%BC%88%E6%B5%B7%E5%8D%97%EF%BC%89%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8`,
          // url: `${easySeries}/ecmall/static/xfpZone.do`
        },
        {
          img: require('@/assets/img/home/yirenzheng.png'),
          text: '易认证',
          btnText: this.isAuthentication ? '查看' : '申请',
          hidden:
            USER_TYPE.PERSONAL === this.userType ||
            this.administrator === ADMIN.NO, // 仅限管理员申请，申请后显示查看按钮，其它身份不显示。
          url: `${easySeries}/ecmall/knowledgeInnovation/showKnowledgeInnovationAbilityEvaluation.do`,
        },
      ];
      arr = arr.filter((item) => !item.hidden);
      return [...arr];
    },
  },
  mounted() {},
  methods: {
    toOpen(data) {
      if (data.url) {
        if (data.url.substr(0,4) !== 'http') {
          this.$router.push({
            path: data.url
          })
        } else {
          window.open(data.url);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-service {
  background: #ffffff;
  margin-top: 20px;
  border: 1px solid #d9d9d9;
  .title {
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 44px;
    background: #f5f5f5;
    padding-left: 20px;
    border-bottom: 1px solid #d9d9d9;
    color: #333;
    .text {
      margin-left: 10px;
    }
  }

  /* & > div:nth-child(1) {
    padding: 20px 30px;
    background: url('~@/assets/img/home/service-icon.png') #ffffff no-repeat left center;
  } */

  & > div:nth-child(2) {
    display: flex;
    // padding-bottom: 20px;
    padding: 20px;

    > div {
      flex: 1;
      margin-right: 20px;
      border: 1px solid #d9d9d9;
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;

      > img {
        vertical-align: top;
      }

      > div:nth-child(2) {
        font-weight: bold;
        font-size: 16px;
        line-height: 16px;
        margin: 10px 0 20px;
      }

      > div.btn-80-30:nth-child(3) {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 30px;
        border: 1px solid #c5c5c5;
        color: #333333;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #2587ff;
          border-color: #bedbff;
          background-color: #e8efff;
        }
      }
      > div.btn-80-30-plain:nth-child(3) {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 30px;
        border: 1px solid #2587ff;
        color: #2587ff;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background: #e8efff;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
